
declare var AuthBar: any;
// import acceleratorApi from '@/api/accelerator.api';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
// import HelperService from '@/services/helpers.service';
import Env from '@/services/env.service';

@Component({
  components: {
  },
})
export default class SignInEmail extends Vue {
  public error: string = '';
  public valid: boolean = false;
  public email: string = '';
  public emailLoading: boolean = false;
  public emailTimeout: any;

  @Watch('email')
  public onPropertyChanged(value: string, oldValue: string) {
    this.error = '';
    localStorage.setItem('signInEmail', value);
  }

  public closeModal() {
    this.$store.commit('setModal', '');
  }

  public signUpPage() {
    this.$store.commit('setModal', 'auth_signUpEmail');
  }

  public keyUpListener(e: any) {
    if (e.keyCode === 13) {
      this.next();
    }
  }

  public async next() {
    this.error = '';
    this.emailLoading = true;

    if (this.isEmailValid(this.email)) {
       console.log(Env.get("VUE_APP_AUTH_BACK_URL") + "/login");
        location.href = Env.get("VUE_APP_AUTH_BACK_URL") + "/login";    
    } else {
      this.error = 'Please enter a valid email address';
      this.emailLoading = false;
    }
   
  }
  isEmailValid(email?: string) {
    let valid = true;

    if (!email || !email.length) {
      valid = false;
    } else if (email.indexOf('@') === -1) {
      valid = false;
    }

    return valid;
  }


  public mounted() {
    // this.$store.commit('setAuthFlowEmail', undefined);
    this.email = localStorage.getItem('signInEmail') || '';
    window.addEventListener('keyup', this.keyUpListener)
  }

  public destroyed() {
    window.removeEventListener('keyup', this.keyUpListener)
  }
}

